(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire90c1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire90c1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1RLna", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $15bf7ce1a8843b98$export$6503ec6e8aabbaf; }, function (v) { return $15bf7ce1a8843b98$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $15bf7ce1a8843b98$export$f7ad0328861e2f03; }, function (v) { return $15bf7ce1a8843b98$export$f7ad0328861e2f03 = v; });
var $15bf7ce1a8843b98$export$6503ec6e8aabbaf;
var $15bf7ce1a8843b98$export$f7ad0328861e2f03;
"use strict";
var $15bf7ce1a8843b98$var$mapping = new Map();
function $15bf7ce1a8843b98$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$15bf7ce1a8843b98$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $15bf7ce1a8843b98$var$resolve(id) {
    var resolved = $15bf7ce1a8843b98$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$15bf7ce1a8843b98$export$6503ec6e8aabbaf = $15bf7ce1a8843b98$var$register;
$15bf7ce1a8843b98$export$f7ad0328861e2f03 = $15bf7ce1a8843b98$var$resolve;

});

parcelRegister("kcZ9B", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $eb645d88b5194bd0$export$bdfd709ae4826697; }, function (v) { return $eb645d88b5194bd0$export$bdfd709ae4826697 = v; });
var $eb645d88b5194bd0$export$bdfd709ae4826697;
var $eb645d88b5194bd0$export$c9e73fbda7da57b6;
var $eb645d88b5194bd0$export$5a759dc7a1cfb72a;
"use strict";
var $eb645d88b5194bd0$var$bundleURL = {};
function $eb645d88b5194bd0$var$getBundleURLCached(id) {
    var value = $eb645d88b5194bd0$var$bundleURL[id];
    if (!value) {
        value = $eb645d88b5194bd0$var$getBundleURL();
        $eb645d88b5194bd0$var$bundleURL[id] = value;
    }
    return value;
}
function $eb645d88b5194bd0$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $eb645d88b5194bd0$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $eb645d88b5194bd0$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $eb645d88b5194bd0$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$eb645d88b5194bd0$export$bdfd709ae4826697 = $eb645d88b5194bd0$var$getBundleURLCached;
$eb645d88b5194bd0$export$c9e73fbda7da57b6 = $eb645d88b5194bd0$var$getBaseURL;
$eb645d88b5194bd0$export$5a759dc7a1cfb72a = $eb645d88b5194bd0$var$getOrigin;

});

parcelRegister("2REAb", function(module, exports) {


module.exports = (parcelRequire("4bdki"))((parcelRequire("1RLna")).resolve("XLihe")).then(()=>parcelRequire("6oUmN"));

});
parcelRegister("4bdki", function(module, exports) {
"use strict";

var $18ada = parcelRequire("18ada");
module.exports = $18ada(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("18ada", function(module, exports) {
"use strict";
var $0d2e758aca2eb045$var$cachedBundles = {};
var $0d2e758aca2eb045$var$cachedPreloads = {};
var $0d2e758aca2eb045$var$cachedPrefetches = {};
function $0d2e758aca2eb045$var$getCache(type) {
    switch(type){
        case "preload":
            return $0d2e758aca2eb045$var$cachedPreloads;
        case "prefetch":
            return $0d2e758aca2eb045$var$cachedPrefetches;
        default:
            return $0d2e758aca2eb045$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $0d2e758aca2eb045$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("89xWy", function(module, exports) {


module.exports = (parcelRequire("4bdki"))((parcelRequire("1RLna")).resolve("lpM7w")).then(()=>parcelRequire("7y9yw"));

});

parcelRegister("8zrVn", function(module, exports) {


module.exports = (parcelRequire("4bdki"))((parcelRequire("1RLna")).resolve("6E1Zq")).then(()=>parcelRequire("dTXJT"));

});

var $c9b40efb3f27705f$exports = {};


(parcelRequire("1RLna")).register((parcelRequire("kcZ9B")).getBundleURL("2Uguk"), JSON.parse('["2Uguk","index.js","XLihe","splide.esm.js","lpM7w","splide-extension-video.esm.js","6E1Zq","popup.js"]'));

"use strict";
(()=>{
    var c = class extends Event {
        oldState;
        newState;
        constructor(t, { oldState: o = "", newState: r = "", ...i } = {}){
            super(t, i), this.oldState = String(o || ""), this.newState = String(r || "");
        }
    }, N = new WeakMap;
    function P(e, t, o) {
        N.set(e, setTimeout(()=>{
            N.has(e) && e.dispatchEvent(new c("toggle", {
                cancelable: !1,
                oldState: t,
                newState: o
            }));
        }, 0));
    }
    var x = globalThis.ShadowRoot || function() {}, V = globalThis.HTMLDialogElement || function() {}, b = new WeakMap, p = new WeakMap, h = new WeakMap;
    function y(e) {
        return h.get(e) || "hidden";
    }
    var L = new WeakMap;
    function O(e) {
        let t = e.popoverTargetElement;
        if (!(t instanceof HTMLElement)) return;
        let o = y(t);
        e.popoverTargetAction === "show" && o === "showing" || e.popoverTargetAction === "hide" && o === "hidden" || (o === "showing" ? v(t, !0, !0) : f(t, !1) && (L.set(t, e), H(t)));
    }
    function f(e, t) {
        return !(e.popover !== "auto" && e.popover !== "manual" || !e.isConnected || t && y(e) !== "showing" || !t && y(e) !== "hidden" || e instanceof V && e.hasAttribute("open") || document.fullscreenElement === e);
    }
    function F(e) {
        return e ? Array.from(p.get(e.ownerDocument) || []).indexOf(e) + 1 : 0;
    }
    function $(e) {
        let t = W(e), o = U(e);
        return F(t) > F(o) ? t : o;
    }
    function M(e) {
        let t = p.get(e);
        for (let o of t || [])if (!o.isConnected) t.delete(o);
        else return o;
        return null;
    }
    function d(e) {
        return typeof e.getRootNode == "function" ? e.getRootNode() : e.parentNode ? d(e.parentNode) : e;
    }
    function W(e) {
        for(; e;){
            if (e instanceof HTMLElement && e.popover === "auto" && h.get(e) === "showing") return e;
            if (e = e instanceof Element && e.assignedSlot || e.parentElement || d(e), e instanceof x && (e = e.host), e instanceof Document) return;
        }
    }
    function U(e) {
        for(; e;){
            let t = e.popoverTargetElement;
            if (t instanceof HTMLElement) return t;
            if (e = e.parentElement || d(e), e instanceof x && (e = e.host), e instanceof Document) return;
        }
    }
    function G(e) {
        let t = new Map, o = 0;
        for (let l of p.get(e.ownerDocument) || [])t.set(l, o), o += 1;
        t.set(e, o), o += 1;
        let r = null;
        function i(l) {
            let a = W(l);
            if (a === null) return null;
            let T = t.get(a);
            (r === null || t.get(r) < T) && (r = a);
        }
        return i(e.parentElement || d(e)), r;
    }
    function Q(e) {
        return e.hidden || e instanceof x || (e instanceof HTMLButtonElement || e instanceof HTMLInputElement || e instanceof HTMLSelectElement || e instanceof HTMLTextAreaElement || e instanceof HTMLOptGroupElement || e instanceof HTMLOptionElement || e instanceof HTMLFieldSetElement) && e.disabled || e instanceof HTMLInputElement && e.type === "hidden" || e instanceof HTMLAnchorElement && e.href === "" ? !1 : typeof e.tabIndex == "number" && e.tabIndex !== -1;
    }
    function _(e) {
        if (e.shadowRoot && e.shadowRoot.delegatesFocus !== !0) return null;
        let t = e;
        t.shadowRoot && (t = t.shadowRoot);
        let o = t.querySelector("[autofocus]");
        if (o) return o;
        {
            let l = t.querySelectorAll("slot");
            for (let a of l){
                let T = a.assignedElements({
                    flatten: !0
                });
                for (let n of T){
                    if (n.hasAttribute("autofocus")) return n;
                    if (o = n.querySelector("[autofocus]"), o) return o;
                }
            }
        }
        let r = e.ownerDocument.createTreeWalker(t, NodeFilter.SHOW_ELEMENT), i = r.currentNode;
        for(; i;){
            if (Q(i)) return i;
            i = r.nextNode();
        }
    }
    function J(e) {
        _(e)?.focus();
    }
    var S = new WeakMap;
    function H(e) {
        if (!f(e, !1)) return;
        let t = e.ownerDocument;
        if (!e.dispatchEvent(new c("beforetoggle", {
            cancelable: !0,
            oldState: "closed",
            newState: "open"
        })) || !f(e, !1)) return;
        let o = !1;
        if (e.popover === "auto") {
            let i = e.getAttribute("popover"), l = G(e) || t;
            if (w(l, !1, !0), i !== e.getAttribute("popover") || !f(e, !1)) return;
        }
        M(t) || (o = !0), S.delete(e);
        let r = t.activeElement;
        e.classList.add(":popover-open"), h.set(e, "showing"), b.has(t) || b.set(t, new Set), b.get(t).add(e), J(e), e.popover === "auto" && (p.has(t) || p.set(t, new Set), p.get(t).add(e), C(L.get(e), !0)), o && r && e.popover === "auto" && S.set(e, r), P(e, "closed", "open");
    }
    function v(e, t = !1, o = !1) {
        if (!f(e, !0)) return;
        let r = e.ownerDocument;
        if (e.popover === "auto" && (w(e, t, o), !f(e, !0)) || (C(L.get(e), !1), L.delete(e), o && (e.dispatchEvent(new c("beforetoggle", {
            oldState: "open",
            newState: "closed"
        })), !f(e, !0)))) return;
        b.get(r)?.delete(e), p.get(r)?.delete(e), e.classList.remove(":popover-open"), h.set(e, "hidden"), o && P(e, "open", "closed");
        let i = S.get(e);
        i && (S.delete(e), t && i.focus());
    }
    function B(e, t = !1, o = !1) {
        let r = M(e);
        for(; r;)v(r, t, o), r = M(e);
    }
    function w(e, t, o) {
        let r = e.ownerDocument || e;
        if (e instanceof Document) return B(r, t, o);
        let i = null, l = !1;
        for (let a of p.get(r) || [])if (a === e) l = !0;
        else if (l) {
            i = a;
            break;
        }
        if (!l) return B(r, t, o);
        for(; i && y(i) === "showing" && p.get(r)?.size;)v(i, t, o);
    }
    var A = new WeakMap;
    function D(e) {
        if (!e.isTrusted) return;
        let t = e.composedPath()[0];
        if (!t) return;
        let o = t.ownerDocument;
        if (!M(o)) return;
        let i = $(t);
        if (i && e.type === "pointerdown") A.set(o, i);
        else if (e.type === "pointerup") {
            let l = A.get(o) === i;
            A.delete(o), l && w(i || o, !1, !0);
        }
    }
    var k = new WeakMap;
    function C(e, t = !1) {
        if (!e) return;
        k.has(e) || k.set(e, e.getAttribute("aria-expanded"));
        let o = e.popoverTargetElement;
        if (o instanceof HTMLElement && o.popover === "auto") e.setAttribute("aria-expanded", String(t));
        else {
            let r = k.get(e);
            r ? e.setAttribute("aria-expanded", r) : e.removeAttribute("aria-expanded");
        }
    }
    var q = globalThis.ShadowRoot || function() {};
    function j() {
        return typeof HTMLElement < "u" && typeof HTMLElement.prototype == "object" && "popover" in HTMLElement.prototype;
    }
    function g(e, t, o) {
        let r = e[t];
        Object.defineProperty(e, t, {
            value (i) {
                return r.call(this, o(i));
            }
        });
    }
    var X = /(^|[^\\]):popover-open\b/g;
    function Y() {
        return typeof globalThis.CSSLayerBlockRule == "function";
    }
    function Z() {
        let e = Y();
        return `
${e ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${e ? "}" : ""}
`;
    }
    var m = null;
    function I(e) {
        let t = Z();
        if (m === null) try {
            m = new CSSStyleSheet, m.replaceSync(t);
        } catch  {
            m = !1;
        }
        if (m === !1) {
            let o = document.createElement("style");
            o.textContent = t, e instanceof Document ? e.head.prepend(o) : e.prepend(o);
        } else e.adoptedStyleSheets = [
            m,
            ...e.adoptedStyleSheets
        ];
    }
    function K() {
        if (typeof window > "u") return;
        window.ToggleEvent = window.ToggleEvent || c;
        function e(n) {
            return n?.includes(":popover-open") && (n = n.replace(X, "$1.\\:popover-open")), n;
        }
        g(Document.prototype, "querySelector", e), g(Document.prototype, "querySelectorAll", e), g(Element.prototype, "querySelector", e), g(Element.prototype, "querySelectorAll", e), g(Element.prototype, "matches", e), g(Element.prototype, "closest", e), g(DocumentFragment.prototype, "querySelectorAll", e), Object.defineProperties(HTMLElement.prototype, {
            popover: {
                enumerable: !0,
                configurable: !0,
                get () {
                    if (!this.hasAttribute("popover")) return null;
                    let n = (this.getAttribute("popover") || "").toLowerCase();
                    return n === "" || n == "auto" ? "auto" : "manual";
                },
                set (n) {
                    this.setAttribute("popover", n);
                }
            },
            showPopover: {
                enumerable: !0,
                configurable: !0,
                value () {
                    H(this);
                }
            },
            hidePopover: {
                enumerable: !0,
                configurable: !0,
                value () {
                    v(this, !0, !0);
                }
            },
            togglePopover: {
                enumerable: !0,
                configurable: !0,
                value (n) {
                    h.get(this) === "showing" && n === void 0 || n === !1 ? v(this, !0, !0) : (n === void 0 || n === !0) && H(this);
                }
            }
        });
        let t = Element.prototype.attachShadow;
        t && Object.defineProperties(Element.prototype, {
            attachShadow: {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value (n) {
                    let s = t.call(this, n);
                    return I(s), s;
                }
            }
        });
        let o = HTMLElement.prototype.attachInternals;
        o && Object.defineProperties(HTMLElement.prototype, {
            attachInternals: {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value () {
                    let n = o.call(this);
                    return n.shadowRoot && I(n.shadowRoot), n;
                }
            }
        });
        let r = new WeakMap;
        function i(n) {
            Object.defineProperties(n.prototype, {
                popoverTargetElement: {
                    enumerable: !0,
                    configurable: !0,
                    set (s) {
                        if (s === null) this.removeAttribute("popovertarget"), r.delete(this);
                        else if (s instanceof Element) this.setAttribute("popovertarget", ""), r.set(this, s);
                        else throw new TypeError("popoverTargetElement must be an element or null");
                    },
                    get () {
                        if (this.localName !== "button" && this.localName !== "input" || this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button" || this.disabled || this.form && this.type === "submit") return null;
                        let s = r.get(this);
                        if (s && s.isConnected) return s;
                        if (s && !s.isConnected) return r.delete(this), null;
                        let u = d(this), E = this.getAttribute("popovertarget");
                        return (u instanceof Document || u instanceof q) && E && u.getElementById(E) || null;
                    }
                },
                popoverTargetAction: {
                    enumerable: !0,
                    configurable: !0,
                    get () {
                        let s = (this.getAttribute("popovertargetaction") || "").toLowerCase();
                        return s === "show" || s === "hide" ? s : "toggle";
                    },
                    set (s) {
                        this.setAttribute("popovertargetaction", s);
                    }
                }
            });
        }
        i(HTMLButtonElement), i(HTMLInputElement);
        let l = (n)=>{
            let s = n.composedPath(), u = s[0];
            if (!(u instanceof Element) || u?.shadowRoot) return;
            let E = d(u);
            if (!(E instanceof q || E instanceof Document)) return;
            let R = s.find((z)=>z.matches?.("[popovertargetaction],[popovertarget]"));
            if (R) {
                O(R), n.preventDefault();
                return;
            }
        }, a = (n)=>{
            let s = n.key, u = n.target;
            !n.defaultPrevented && u && (s === "Escape" || s === "Esc") && w(u.ownerDocument, !0, !0);
        };
        ((n)=>{
            n.addEventListener("click", l), n.addEventListener("keydown", a), n.addEventListener("pointerdown", D), n.addEventListener("pointerup", D);
        })(document), I(document);
    }
    j() || K();
})();


var $05a697981a0796ab$exports = {};
/*!
 * baffle 0.3.6 - A tiny javascript library for obfuscating and revealing text in DOM elements.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/baffle
 * License: MIT
 */ !function(t, e) {
    $05a697981a0796ab$exports = e();
}($05a697981a0796ab$exports, function() {
    return function(t) {
        function e(r) {
            if (n[r]) return n[r].exports;
            var i = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.p = "", e(0);
    }([
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            var i = n(2), o = r(i);
            t.exports = o["default"];
        },
        function(t, e) {
            "use strict";
            function n(t, e) {
                for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
                return t;
            }
            function r(t, e) {
                return t.split("").map(e).join("");
            }
            function i(t) {
                return t[Math.floor(Math.random() * t.length)];
            }
            function o(t, e) {
                for(var n = 0, r = t.length; n < r; n++)e(t[n], n);
            }
            function u(t) {
                return t.map(function(t, e) {
                    return !!t && e;
                }).filter(function(t) {
                    return t !== !1;
                });
            }
            function s(t) {
                return "string" == typeof t ? [].slice.call(document.querySelectorAll(t)) : [
                    NodeList,
                    HTMLCollection
                ].some(function(e) {
                    return t instanceof e;
                }) ? [].slice.call(t) : t.nodeType ? [
                    t
                ] : t;
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.extend = n, e.mapString = r, e.sample = i, e.each = o, e.getTruthyIndices = u, e.getElements = s;
        },
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            function i(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var o = n(1), u = n(3), s = r(u), c = {
                characters: "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz~!@#$%^&*()-+=[]{}|;:,./<>?",
                exclude: [
                    " "
                ],
                speed: 50
            }, a = function() {
                function t(e, n) {
                    i(this, t), this.options = (0, o.extend)(Object.create(c), n), this.elements = (0, o.getElements)(e).map(s["default"]), this.running = !1;
                }
                return t.prototype.once = function() {
                    var t = this;
                    return (0, o.each)(this.elements, function(e) {
                        return e.write(t.options.characters, t.options.exclude);
                    }), this.running = !0, this;
                }, t.prototype.start = function() {
                    var t = this;
                    return clearInterval(this.interval), (0, o.each)(this.elements, function(t) {
                        return t.init();
                    }), this.interval = setInterval(function() {
                        return t.once();
                    }, this.options.speed), this.running = !0, this;
                }, t.prototype.stop = function() {
                    return clearInterval(this.interval), this.running = !1, this;
                }, t.prototype.set = function(t) {
                    return (0, o.extend)(this.options, t), this.running && this.start(), this;
                }, t.prototype.text = function(t) {
                    var e = this;
                    return (0, o.each)(this.elements, function(n) {
                        n.text(t(n.value)), e.running || n.write();
                    }), this;
                }, t.prototype.reveal = function() {
                    var t = this, e = arguments.length <= 0 || void 0 === arguments[0] ? 0 : arguments[0], n = arguments.length <= 1 || void 0 === arguments[1] ? 0 : arguments[1], r = e / this.options.speed || 1, i = function() {
                        clearInterval(t.interval), t.running = !0, t.interval = setInterval(function() {
                            var e = t.elements.filter(function(t) {
                                return !t.bitmap.every(function(t) {
                                    return !t;
                                });
                            });
                            (0, o.each)(e, function(e) {
                                var n = Math.ceil(e.value.length / r);
                                e.decay(n).write(t.options.characters, t.options.exclude);
                            }), e.length || (t.stop(), (0, o.each)(t.elements, function(t) {
                                return t.init();
                            }));
                        }, t.options.speed);
                    };
                    return setTimeout(i, n), this;
                }, t;
            }();
            e["default"] = function(t, e) {
                return new a(t, e);
            };
        },
        function(t, e, n) {
            "use strict";
            function r(t, e) {
                if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }
            function i(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
            }
            function o(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var u = n(1), s = function() {
                function t(e) {
                    o(this, t), this.value = e, this.init();
                }
                return t.prototype.init = function() {
                    return this.bitmap = this.value.split("").map(function() {
                        return 1;
                    }), this;
                }, t.prototype.render = function() {
                    var t = this, e = arguments.length <= 0 || void 0 === arguments[0] ? [] : arguments[0], n = arguments.length <= 1 || void 0 === arguments[1] ? [] : arguments[1];
                    return e.length ? (0, u.mapString)(this.value, function(r, i) {
                        return n.indexOf(r) > -1 ? r : t.bitmap[i] ? (0, u.sample)(e) : r;
                    }) : this.value;
                }, t.prototype.decay = function() {
                    for(var t = arguments.length <= 0 || void 0 === arguments[0] ? 1 : arguments[0]; t--;){
                        var e = (0, u.getTruthyIndices)(this.bitmap);
                        this.bitmap[(0, u.sample)(e)] = 0;
                    }
                    return this;
                }, t.prototype.text = function() {
                    var t = arguments.length <= 0 || void 0 === arguments[0] ? this.value : arguments[0];
                    return this.value = t, this.init(), this;
                }, t;
            }(), c = function(t) {
                function e(n) {
                    o(this, e);
                    var i = r(this, t.call(this, n.textContent));
                    return i.element = n, i;
                }
                return i(e, t), e.prototype.write = function(t, e) {
                    return this.element.textContent = this.render(t, e), this;
                }, e;
            }(s);
            e["default"] = function(t) {
                return new c(t);
            };
        }
    ]);
});


class $35d6ddc0a13b5a74$var$CountUpElement extends HTMLElement {
    constructor(){
        super();
        this.observerInstance = null;
        this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    connectedCallback() {
        this.setupObserver();
    }
    disconnectedCallback() {
        if (this.observerInstance) this.observerInstance.disconnect();
    }
    setupObserver() {
        this.observerInstance = new IntersectionObserver((entries)=>this.handleIntersection(entries), {
            threshold: 0.1
        });
        this.observerInstance.observe(this);
    }
    handleIntersection(entries) {
        const entry = entries[0];
        if (entry.isIntersecting && !this.classList.contains("animated")) this.startAnimation();
    }
    startAnimation() {
        this.classList.add("animated");
        const endValue = parseInt(this.textContent.trim(), 10);
        if (!isNaN(endValue)) {
            if (this.prefersReducedMotion) this.textContent = endValue.toString();
            else {
                this.textContent = "0";
                this.animateCountUp(endValue);
            }
        } else console.warn("Invalid number inside element:", this);
    }
    animateCountUp(endValue, duration = 1000) {
        let startTime = null;
        const updateValue = (currentTime)=>{
            if (!startTime) startTime = currentTime;
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const currentValue = Math.round(endValue * progress);
            this.textContent = currentValue;
            if (progress < 1) requestAnimationFrame(updateValue);
            else this.textContent = endValue;
        };
        requestAnimationFrame(updateValue);
    }
}
customElements.define("count-up", $35d6ddc0a13b5a74$var$CountUpElement);


/**
 * This work is licensed under the W3C Software and Document License
 * (http://www.w3.org/Consortium/Legal/2015/copyright-software-and-document).
 */ class $dca0e909e136e961$var$MediaAffordancesElement extends HTMLElement {
    constructor(){
        super();
        this.mqls = [];
        this.observers = [];
        this.supportedAffordances = new Set();
    }
    observeAffordanceChange(cb) {
        this.observers.push(cb);
    }
    notifyChange() {
        let intersection = new Set();
        for (let elem of this.mqls)if (elem.matches && this.supportedAffordances.has(elem.__affordance)) intersection.add(elem.__affordance);
        let arr = [
            ...intersection
        ];
        if (arr.length > 0) this.setAttribute("mq-matched", arr.join(" "));
        else this.removeAttribute("mq-matched");
        let affordance = arr[0];
        if (affordance) this.setAttribute("affordance", affordance);
        else this.removeAttribute("affordance");
        this.observers.forEach((cb)=>{
            cb(intersection, this.__matching);
        });
    }
    static get observedAttributes() {
        return [
            "mq-affordances"
        ];
    }
    connectedCallback() {
        let newValue = getComputedStyle(this).getPropertyValue("--const-mq-affordances");
        this.connectListeners(newValue);
    }
    connectListeners(newValue = "") {
        if (newValue.trim().length === 0) return;
        newValue.split("|").forEach((segment)=>{
            let mq = segment.trim().match(/\[([^\]]*)/)[1];
            let names = segment.replace(`[${mq}]`, "").trim().split(" ");
            let mql = window.matchMedia(mq);
            mql.__affordance = names[0]; // one for now
            mql.onchange = ()=>this.notifyChange();
            this.mqls.push(mql);
        }, this);
        this.notifyChange();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this.connectListeners(newValue);
    }
}
// ----------------------------------------------------
(()=>{
    let lastUId = 0;
    let nextUId = ()=>{
        return `cp${++lastUId}`;
    };
    let getLabels = (regionset)=>{
        return [
            ...regionset.children
        ].filter((el)=>/^H\d$/.test(el.tagName) || el.tagName === "SPICY-H");
    };
    let getContentEls = (regionset)=>{
        return [
            ...regionset.children
        ].filter((el)=>!/^H\d$/.test(el.tagName));
    };
    let ensureId = (el)=>{
        el.id = el.id || nextUId();
        return el.id;
    };
    let style = document.createElement("style");
    style.innerHTML = `
	:where(spicy-sections > [affordance*="collapse"])::after { 
		content: ' ';
		display: inline-block;
		transform: rotate(45deg) translate(.3rem, 0);
    border-inline-end: 2px solid;
    border-block-end: 2px solid;
    block-size: 0.7rem;
    inline-size: 0.7rem;
    margin-inline-end: 0.7rem;
	} 

	:where(spicy-sections > .hide) {
		display: none !important;
	} 

	:where(spicy-sections > [affordance*="collapse"][aria-expanded="true"])::before, 
	:where(spicy-sections > [affordance*="collapse"][aria-expanded="true"])::after {
		transform: rotate(-135deg) translate(-.6rem, -0.3rem);
	}
	`;
    document.head.prepend(style);
    const template = `
	<style>
		:root {
			font-size: 1rem;
		}

		:host([hidden]),
		::slotted([hidden]) {
			display: none;
		}
		
		::slotted(spicy-h) {
			display: block;
		}

		::slotted(h1),
		::slotted(h2),
		::slotted(h3),
		::slotted(h4),
		::slotted(h5),
		::slotted(h6),
		::slotted(spicy-h){
			margin-right: 1rem;
		}

		[part="tab-bar"] ::slotted([tabindex="0"]) {
			border-bottom: 1px solid blue;
		}

		.hide {
			display: none;
		}
		
		[part="tab-list"] { 
			display: flex; 
			overflow: hidden;
			white-space: nowrap;
		}
	</style>
	<div part="tab-bar">
		<!-- The region/tablist should have a label -->
		<div part="tab-list" role="tablist"><slot name="tabListSlot"></slot></div>
	</div>
	<content part="content-panels">
		<slot default></slot>
	</content>
	`;
    class RegionSet extends $dca0e909e136e961$var$MediaAffordancesElement {
        __defaults;
        __tabListEl;
        // tabs and exclusive collapses should have the same affordance object?
        __affordanceConf = {
            collapse: {
                // can take a condition to force, check-like
                toggle: (label, condition)=>{
                    let state = typeof condition === "boolean" ? condition : !label.affordanceState.expanded;
                    let contentEl = label.nextElementSibling;
                    label.affordanceState.expanded = state;
                    label.affordanceState.nonExclusiveExpanded = state;
                    label.setAttribute("aria-expanded", state);
                    if (state) {
                        label.setAttribute("expanded", "");
                        contentEl.classList.remove("hide");
                    } else {
                        label.removeAttribute("expanded");
                        contentEl.classList.add("hide");
                    }
                }
            },
            "exclusive-collapse": {
                // ignores condition, radio-like
                toggle: (label)=>{
                    let labels = getLabels(label.parentElement);
                    let siblings = labels.filter((c)=>c !== label);
                    let index = labels.findIndex((c)=>c === label);
                    siblings.forEach((sibLabel, i)=>{
                        let relatedContent = sibLabel.nextElementSibling;
                        relatedContent.classList.add("hide");
                        sibLabel.tabIndex = -1;
                        sibLabel.setAttribute("aria-expanded", "false");
                        sibLabel.affordanceState.exclusiveExpanded = false;
                    });
                    label.tabIndex = 0;
                    label.parentElement.affordanceState.exclusiveSelection.index = index; // TODO: nope, fix/remove this?
                    label.nextElementSibling.classList.remove("hide");
                    label.setAttribute("aria-expanded", "true");
                    label.affordanceState.exclusiveExpanded = true;
                    label.focus();
                }
            },
            "tab-bar": {
                // ignores condition, radio-like
                toggle: (label)=>{
                    let labels = getLabels(label.parentElement);
                    let siblings = labels.filter((c)=>c !== label);
                    let index = labels.findIndex((c)=>c === label);
                    siblings.forEach((sibLabel, i)=>{
                        let relatedContent = sibLabel.nextElementSibling;
                        relatedContent.classList.add("hide");
                        sibLabel.tabIndex = -1;
                        sibLabel.setAttribute("aria-selected", "false");
                        sibLabel.affordanceState.exclusiveExpanded = false;
                    });
                    label.tabIndex = 0;
                    label.parentElement.affordanceState.exclusiveSelection.index = index;
                    label.nextElementSibling.classList.remove("hide");
                    label.setAttribute("aria-selected", "true");
                    label.affordanceState.exclusiveExpanded = true;
                    label.focus();
                }
            }
        };
        __setSize = (labelEls, contentEls)=>{
            this.__size = Math.min(labelEls.length, contentEls.length);
            if (labelEls.length !== this.__size) console.warn("mismatch in tab-set label/content pairs...");
            labelEls.forEach((labelEl, i)=>{
                let contentEl = contentEls[i];
                if (!labelEl.initialized) {
                    labelEl.initialized = true; // TODO: this used to be shadow, do i need it?
                    let defs = this.__defaults.defaultActive;
                    // this assumes it is about collapses
                    labelEl.affordanceState = {
                        expanded: defs.includes(labelEl),
                        active: false,
                        // activate in the current mode
                        activate: ()=>{
                            if (this.affordanceState.current) this.__affordanceConf[this.affordanceState.current].toggle(labelEl);
                        }
                    };
                    let defaultExclusive = defs.length === 0 ? labelEls[0] : defs[defs.length - 1];
                    this.affordanceState.exclusiveSelection.index = labelEls.indexOf(defaultExclusive);
                }
                labelEl.setMode = (mode)=>{
                    if (mode === "non-exclusive") {
                        let isExpanded = labelEl.affordanceState.expanded;
                        labelEl.setAttribute("affordance", "collapse");
                        labelEl.setAttribute("tabindex", "0");
                        labelEl.setAttribute("aria-controls", contentEl.id);
                        labelEl.setAttribute("role", "button");
                        labelEl.setAttribute("aria-expanded", isExpanded);
                        labelEl.nextElementSibling.classList.toggle("hide", !isExpanded);
                    } else if (mode === "exclusive") {
                        let isExpanded = labelEls.indexOf(labelEl) === this.affordanceState.exclusiveSelection.index;
                        labelEl.setAttribute("affordance", "collapse");
                        labelEl.setAttribute("tabindex", isExpanded ? 0 : -1);
                        labelEl.setAttribute("role", "button");
                        labelEl.setAttribute("aria-expanded", isExpanded);
                        labelEl.setAttribute("aria-controls", contentEl.id);
                        labelEl.nextElementSibling.classList.toggle("hide", !isExpanded);
                    } else {
                        labelEl.removeAttribute("tabIndex");
                        labelEl.removeAttribute("affordance");
                        labelEl.removeAttribute("aria-expanded");
                        labelEl.removeAttribute("role");
                    }
                };
            });
        };
        __projectTabBar = ()=>{
            this.__removeProjections();
            getLabels(this).forEach((tabSource, i)=>{
                let selected = false;
                let tabIndex = -1;
                tabSource.setMode();
                tabSource.slot = "tabListSlot";
                tabSource.setAttribute("role", "tab");
                let contentSource = tabSource.nextElementSibling;
                contentSource.tabIndex = 0;
                tabSource.setAttribute("aria-controls", ensureId(contentSource));
                contentSource.setAttribute("role", "tabpanel");
                contentSource.setAttribute("aria-labelledby", tabSource.id);
                if (i === this.affordanceState.exclusiveSelection.index) {
                    tabIndex = 0;
                    selected = true;
                }
                tabSource.setAttribute("aria-selected", selected);
                tabSource.tabIndex = tabIndex;
                contentSource.classList.toggle("hide", !selected);
            // TODO: aria-orientation :(
            });
        };
        __projectCollapses = (exclusive)=>{
            // TODO: remove projections and... ??
            this.__removeProjections();
            getLabels(this).forEach((label)=>{
                label.setMode(exclusive ? "exclusive" : "non-exclusive");
            });
        };
        __removeProjections = ()=>{
            Array.from(this.children, (child)=>{
                child.removeAttribute("slot");
                child.removeAttribute("affordance");
                child.removeAttribute("role");
                child.removeAttribute("aria-selected");
                child.removeAttribute("aria-controls");
                child.removeAttribute("tabindex");
                child.removeAttribute("aria-expanded");
                child.classList.remove("hide");
            });
        };
        // matching pairs
        __size = 0;
        __configure = ()=>{
            // hmmm
            this.__setSize(getLabels(this), getContentEls(this));
            if (this.affordanceState.current === "tab-bar") {
                this.affordanceState.currentMode = "exclusive";
                this.__projectTabBar();
            } else if (this.affordanceState.current === "collapse") {
                this.affordanceState.currentMode = "non-exclusive";
                this.__projectCollapses();
            } else if (this.affordanceState.current === "exclusive-collapse") {
                this.affordanceState.currentMode = "exclusive";
                this.__projectCollapses(true);
            } else {
                this.affordanceState.currentMode = undefined;
                this.__removeProjections();
            }
            // TODO: hmm, these are DOM changes, we could cache them
            let labelEls = getLabels(this);
            for(let i = 0; i < this.__size; i++){
                let label = labelEls[i];
                // probably add one handler that decides
                if (!label._inited) {
                    label.addEventListener("click", (evt)=>{
                        evt.target.affordanceState.activate();
                    });
                    label._inited = true;
                }
            }
        };
        __childListObserver = new MutationObserver((mutationList)=>{
            // we have to wire up new elements
            let labelEls = getLabels(this);
            let contentEls = getContentEls(this);
            // what if there is a mismatch?
            this.__setSize(labelEls, contentEls);
            this.__configure();
        });
        __tabset;
        affordanceState = {
            exclusiveSelection: {
                index: undefined
            },
            current: undefined,
            currentMode: undefined,
            getLabels: ()=>{
                return getLabels(this);
            }
        };
        honourFragmentLink = ()=>{
            let labels = getLabels(this);
            if (location.hash && this.querySelector(location.hash)) // try to find a label with this ID, or controlled content
            // that contains an element with this ID
            for(let i = 0; i < labels.length; i++){
                let relevantContent = labels[i].getAttribute("aria-controls") && this.querySelector(`#${labels[i].getAttribute("aria-controls")}`);
                if (labels[i] === this.querySelector(location.hash) || relevantContent && relevantContent.querySelector(location.hash)) {
                    labels[i].affordanceState.activate();
                    return;
                }
            }
        };
        // wires up supported affordances
        constructor(){
            super();
            this.supportedAffordances.add("tab-bar");
            this.supportedAffordances.add("collapse");
            this.supportedAffordances.add("exclusive-collapse");
            let checkDefaults = ()=>{
                if (!this.__defaults) this.__defaults = {
                    onMatch: this.hasAttribute("defaults-on-match"),
                    defaultActive: getLabels(this).filter((l)=>l.hasAttribute("default-activate"))
                };
            };
            this.observeAffordanceChange((matching, all)=>{
                if (!this.__defaults) this.__defaults = {
                    onMatch: this.hasAttribute("defaults-on-match"),
                    defaultActive: getLabels(this).filter((l)=>l.hasAttribute("default-activate"))
                };
                this.affordanceState.current = this.getAttribute("affordance");
                this.__configure();
            });
            this.setActiveAffordance = (matching, all)=>{
                checkDefaults();
                this.setAttribute("affordance", matching);
                this.affordanceState.current = matching;
                this.__configure();
            };
            this.attachShadow({
                mode: "open"
            });
            this.shadowRoot.innerHTML = template;
            this.__tabListEl = this.shadowRoot.querySelector("[part='tab-list']");
            this.addEventListener("keydown", (evt)=>{
                let labels = getLabels(this);
                let size = labels.length;
                let cur = this.affordanceState.exclusiveSelection.index;
                let prev = cur === 0 ? size - 1 : cur - 1;
                let next = cur === size - 1 ? 0 : cur + 1;
                // don't trap nested handling
                if (evt.target.parentElement !== evt.currentTarget) return;
                if (this.affordanceState.current === "tab-bar" || this.affordanceState.current === "exclusive-collapse") {
                    if (evt.key === "ArrowLeft" || evt.key === "ArrowUp") {
                        labels[prev].affordanceState.activate();
                        evt.preventDefault();
                    } else if (evt.key === "ArrowRight" || evt.key === "ArrowDown") {
                        labels[next].affordanceState.activate();
                        evt.preventDefault();
                    }
                } else if (evt.key === " " && this.affordanceState.current === "collapse") evt.preventDefault();
            }, false);
            this.addEventListener("keyup", (evt)=>{
                if (evt.key === " " && this.affordanceState.current === "collapse") {
                    evt.target.closest("[affordance]").affordanceState.activate();
                    evt.preventDefault();
                }
            });
        }
        connectedCallback() {
            super.connectedCallback();
            // TODO: handle selection
            if (location.hash) setTimeout(this.honourFragmentLink, 1);
            window.addEventListener("hashchange", this.honourFragmentLink);
            // if you append a fragment with a pair, it should work
            this.__childListObserver.observe(this, {
                childList: true
            });
        }
    }
    customElements.define("spicy-sections", RegionSet);
})();


class $8762eb0d6b7899c2$var$RevealOnScrollHeader extends HTMLElement {
    constructor(){
        super();
        this.headerContainer = null;
        this.previousScrollPosition = 0;
        this.headerHiddenAmount = 0;
        this.isUpdating = false;
    }
    connectedCallback() {
        this.initializeHeader();
    }
    disconnectedCallback() {
        this.removeEventListeners();
    }
    initializeHeader() {
        this.headerContainer = this.parentElement;
        if (!this.headerContainer) return;
        this.applyFixedHeaderStyles();
        this.addEventListeners();
        window.requestAnimationFrame(this.updateHeaderVisibility);
    }
    addEventListeners() {
        window.addEventListener("scroll", this.scrollHandler, {
            passive: true
        });
        window.addEventListener("resize", this.resizeHandler);
    }
    removeEventListeners() {
        window.removeEventListener("scroll", this.scrollHandler, {
            passive: true
        });
        window.removeEventListener("resize", this.resizeHandler);
    }
    scrollHandler = ()=>{
        if (!this.isUpdating) {
            window.requestAnimationFrame(this.updateHeaderVisibility);
            this.isUpdating = true;
        }
    };
    resizeHandler = ()=>{
        this.initializeHeader();
    };
    updateHeaderVisibility = ()=>{
        const activePopup = this.querySelector(".page-header-main-nav sl-popup[active]");
        const currentScrollPosition = Math.max(0, window.scrollY);
        const scrollDistance = this.calculateScrollDistance(currentScrollPosition);
        if (!activePopup) {
            this.updateHeaderHiddenAmount(scrollDistance);
            this.updateHeaderTransform();
        }
        this.updateHeaderAppearance(currentScrollPosition);
        this.previousScrollPosition = currentScrollPosition;
        this.isUpdating = false;
    };
    calculateScrollDistance(currentScrollPosition) {
        const previousScrollPositionCapped = Math.max(0, this.previousScrollPosition);
        return currentScrollPosition - previousScrollPositionCapped;
    }
    updateHeaderHiddenAmount(scrollDistance) {
        this.headerHiddenAmount = Math.max(0, Math.min(this.headerHiddenAmount + scrollDistance, this.getBoundingClientRect().height));
    }
    updateHeaderTransform() {
        this.style.transform = `translate3d(0, -${this.headerHiddenAmount}px, 0)`;
    }
    updateHeaderAppearance(currentScrollPosition) {
        if (currentScrollPosition === 0) this.setTopOfPageAppearance();
        else if (this.headerHiddenAmount < this.getBoundingClientRect().height) this.setPartiallyVisibleAppearance(currentScrollPosition);
        else this.setFullyHiddenAppearance();
    }
    setTopOfPageAppearance() {
        this.classList.add("top-of-page");
        this.classList.remove("bg-present");
    }
    setPartiallyVisibleAppearance(currentScrollPosition) {
        if (currentScrollPosition > this.getBoundingClientRect().height) {
            this.classList.remove("top-of-page");
            this.classList.add("bg-present");
        }
    }
    setFullyHiddenAppearance() {
        this.classList.add("bg-present");
    }
    applyFixedHeaderStyles() {
        this.style.position = "fixed";
        this.style.zIndex = "999";
        this.style.insetInline = "0";
        this.style.insetBlockStart = "0";
        this.headerContainer.style.paddingTop = `${this.getBoundingClientRect().height}px`;
    }
}
customElements.define("reveal-on-scroll-header", $8762eb0d6b7899c2$var$RevealOnScrollHeader);


class $4370e1e4536ec916$var$CollapsibleList extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.render();
        this.setupEventListeners();
    }
    render() {
        this.shadowRoot.innerHTML = `
        <style>
          [aria-expanded="true"] + ul {
            display: block;
          }
          [aria-expanded="false"] + ul {
            display: none;
          }
        </style>
        <div>
          <slot></slot>
        </div>
      `;
    }
    setupEventListeners() {
        const buttons = this.querySelectorAll("button");
        buttons.forEach((button)=>{
            button.setAttribute("aria-expanded", "false");
            const menu = button.nextElementSibling;
            if (menu && menu.tagName === "UL") menu.hidden = true;
            button.addEventListener("click", ()=>{
                const expanded = button.getAttribute("aria-expanded") === "true" || false;
                button.setAttribute("aria-expanded", !expanded);
                if (menu) menu.hidden = !menu.hidden;
            });
        });
    }
}
customElements.define("collapsible-list", $4370e1e4536ec916$var$CollapsibleList);




document.addEventListener("DOMContentLoaded", function() {
    (parcelRequire("2REAb")).then((Splide)=>{
        (parcelRequire("89xWy")).then(({ Video: Video })=>{
            const elementsWithSplideClass = document.getElementsByClassName("splide");
            for (const element of elementsWithSplideClass){
                const splideInstance = new Splide.default(element);
                splideInstance.mount({
                    Video: Video
                });
            }
        });
    });
});


const $649277099dba67c9$var$CLOSE_DELAY_MS = 400;
function $649277099dba67c9$var$initializeFlyoutMenu() {
    const shortcuts = document.querySelectorAll(".main-nav-item");
    let currentOpenPopup = null;
    let closeTimeoutId = null;
    shortcuts.forEach(setupShortcut);
    function setupShortcut(shortcut) {
        const popup = shortcut.querySelector("sl-popup");
        let isMouseOver = false;
        attachEventListeners(shortcut, popup);
        function handleMouseEnter() {
            isMouseOver = true;
            clearTimeout(closeTimeoutId);
            openPopup(popup);
        }
        function handleMouseLeave(e) {
            // in case of leaving one but then hovering over the other element
            if (popup.matches(":hover") || shortcut.matches(":hover")) return;
            isMouseOver = false;
            schedulePopupClose(popup);
        }
        function handleFocusIn() {
            clearTimeout(closeTimeoutId);
            openPopup(popup);
        }
        function handleFocusOut() {
            setTimeout(()=>{
                if (!shortcut.contains(document.activeElement)) closePopup(popup);
            }, 0);
        }
        function schedulePopupClose(popup) {
            clearTimeout(closeTimeoutId);
            closeTimeoutId = setTimeout(()=>{
                if (!isMouseOver) closePopup(popup);
            }, $649277099dba67c9$var$CLOSE_DELAY_MS);
        }
        function attachEventListeners(shortcut, popup) {
            shortcut.addEventListener("mouseenter", handleMouseEnter);
            shortcut.addEventListener("mouseleave", handleMouseLeave);
            popup.addEventListener("mouseenter", handleMouseEnter);
            popup.addEventListener("mouseleave", handleMouseLeave);
            shortcut.addEventListener("focusin", handleFocusIn);
            shortcut.addEventListener("focusout", handleFocusOut);
        }
    }
    function openPopup(popup) {
        if (currentOpenPopup && currentOpenPopup !== popup) closePopup(currentOpenPopup, false);
        clearTimeout(closeTimeoutId);
        popup.classList.remove("exit");
        popup.active = true;
        setTimeout(()=>{
            popup.classList.add("enter");
        }, 10);
        currentOpenPopup = popup;
    }
    function closePopup(popup, animate = true) {
        if (currentOpenPopup !== popup) return;
        if (animate) {
            popup.classList.remove("enter");
            popup.classList.add("exit");
            setTimeout(()=>{
                if (currentOpenPopup === popup) {
                    popup.active = false;
                    popup.classList.remove("exit");
                    currentOpenPopup = null;
                }
            }, 300);
        } else {
            popup.classList.remove("enter", "exit");
            popup.active = false;
            currentOpenPopup = null;
        }
    }
}
const $649277099dba67c9$var$supportsHover = window.matchMedia("(hover: hover)").matches;

if ($649277099dba67c9$var$supportsHover) (parcelRequire("8zrVn")).then(()=>{
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $649277099dba67c9$var$initializeFlyoutMenu);
    else $649277099dba67c9$var$initializeFlyoutMenu();
});


class $409bf580414df8f8$var$JobOffersFilter extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.initializeElements();
        this.initializeJobData();
        this.bindEvents();
    }
    initializeElements() {
        this.form = this.querySelector('[data-js="filter-form"]');
        this.jobList = this.querySelector('[data-js="job-list"]');
        this.rowTemplate = document.getElementById("jobOffersJobRowTemplate");
        this.filterSelects = {
            jobGroup: this.querySelector('[data-js="filter-jobgroup"]'),
            category: this.querySelector('[data-js="filter-category"]'),
            location: this.querySelector('[data-js="filter-location"]')
        };
    }
    initializeJobData() {
        this.jobs = Array.from(this.jobList.querySelectorAll("tr[data-categories]")).map((row)=>({
                title: row.querySelector('[data-js="job-link"]').textContent,
                link: row.querySelector('[data-js="job-link"]').href,
                location: row.querySelector('[data-js="location-cell"]').textContent,
                categories: row.dataset.categories.split(" ")
            }));
    }
    bindEvents() {
        this.form.addEventListener("change", ()=>{
            this.updateJobList();
        });
    }
    updateJobList() {
        const activeFilters = this.getActiveFilters();
        const filteredJobs = this.filterJobs(activeFilters);
        this.renderJobs(filteredJobs);
    }
    getActiveFilters() {
        return Object.entries(this.filterSelects).reduce((activeFilters, [filterName, selectElement])=>{
            const selectedValue = selectElement.value;
            if (selectedValue) activeFilters[filterName] = selectedValue;
            return activeFilters;
        }, {});
    }
    filterJobs(activeFilters) {
        if (Object.keys(activeFilters).length === 0) return this.jobs;
        return this.jobs.filter((job)=>Object.values(activeFilters).every((filterValue)=>job.categories.includes(filterValue)));
    }
    renderJobs(jobsToRender) {
        this.jobList.innerHTML = "";
        jobsToRender.forEach((job)=>{
            const newRow = this.createJobRow(job);
            this.jobList.appendChild(newRow);
        });
    }
    createJobRow(job) {
        const row = this.rowTemplate.content.cloneNode(true);
        const link = row.querySelector('[data-js="job-link"]');
        link.href = job.link;
        link.textContent = job.title;
        row.querySelector('[data-js="location-cell"]').textContent = job.location;
        row.querySelector('[data-js="job-row"]').dataset.categories = job.categories.join(" ");
        return row;
    }
}
customElements.define("job-offers-filter", $409bf580414df8f8$var$JobOffersFilter);


class $a854652ed0f93b65$var$LogoStripe extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) this.addAnimation();
    }
    addAnimation() {
        this.setAttribute("data-animated", true);
        const scrollerInner = this.querySelector(".logo-row");
        if (scrollerInner) {
            const scrollerContent = Array.from(scrollerInner.children);
            scrollerContent.forEach((item)=>{
                const duplicatedItem = item.cloneNode(true);
                duplicatedItem.setAttribute("aria-hidden", true);
                scrollerInner.appendChild(duplicatedItem);
            });
        }
    }
}
customElements.define("logo-stripe", $a854652ed0f93b65$var$LogoStripe);


class $1f3ef02ab8c645b4$var$SineWaveArrow extends HTMLElement {
    constructor(){
        super();
        this.offset = 0;
        this.isAnimating = false;
        this.animationFrame = null;
        this.width = 0;
        this.resizeObserver = null;
        this.mouseX = 0;
        this.currentFrequency = 0;
        this.currentAmplitude = 0;
        this.transitionStartTime = 0;
        this.transitionDuration = 350;
        this.innerHTML = `
      <svg>
        <path class="mirror" />
        <path class="primary" />
      </svg>
      <div class="arrow-head"></div>
    `;
        this.svg = this.querySelector("svg");
        this.primaryPath = this.querySelector(".primary");
        this.mirrorPath = this.querySelector(".mirror");
        this.startAnimation = this.startAnimation.bind(this);
        this.stopAnimation = this.stopAnimation.bind(this);
        this.animate = this.animate.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.addEventListener("mouseenter", this.startAnimation);
        this.addEventListener("mouseleave", this.stopAnimation);
        this.addEventListener("mousemove", this.handleMouseMove);
        this.addEventListener("focus", this.startAnimation);
        this.addEventListener("blur", this.stopAnimation);
    }
    handleMouseMove(event) {
        const rect = this.getBoundingClientRect();
        this.mouseX = event.clientX - rect.left;
    }
    connectedCallback() {
        this.resizeObserver = new ResizeObserver(this.updateDimensions);
        this.resizeObserver.observe(this);
        this.updateDimensions();
    }
    disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }
    updateDimensions() {
        const rect = this.getBoundingClientRect();
        this.width = rect.width;
        this.svg.setAttribute("viewBox", `0 0 ${this.width} 150`);
        if (!this.isAnimating) {
            const straightLine = `M0,75 L${this.width},75`;
            this.primaryPath.setAttribute("d", straightLine);
            this.mirrorPath.setAttribute("d", straightLine);
        }
    }
    static get observedAttributes() {
        return [
            "frequency",
            "amplitude",
            "min-speed",
            "max-speed"
        ];
    }
    get frequency() {
        return Number(this.getAttribute("frequency")) || 2.25;
    }
    get amplitude() {
        return Number(this.getAttribute("amplitude")) || 0.2;
    }
    get minSpeed() {
        return Number(this.getAttribute("min-speed")) || 0.05;
    }
    get maxSpeed() {
        return Number(this.getAttribute("max-speed")) || 0.2;
    }
    getCurrentSpeed() {
        if (!this.isAnimating || !this.width) return this.minSpeed;
        const normalizedX = Math.max(0, Math.min(1, this.mouseX / this.width));
        return this.minSpeed + (this.maxSpeed - this.minSpeed) * normalizedX;
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue && this.isAnimating) {
            this.transitionStartTime = performance.now();
            this.currentFrequency = 0;
            this.currentAmplitude = 0;
        }
    }
    updateTransitionValues(currentTime) {
        const elapsed = currentTime - this.transitionStartTime;
        const progress = Math.min(elapsed / this.transitionDuration, 1);
        const eased = 1 - (1 - progress) * (1 - progress);
        this.currentFrequency = this.frequency * eased;
        this.currentAmplitude = this.amplitude * eased;
    }
    calculateY(x, mirror = false) {
        if (!this.width || isNaN(x)) return 0;
        const distanceFromMouse = Math.abs(x - this.mouseX);
        const maxDistance = this.width / 2;
        const distanceFromEnd = (this.width - x) / this.width;
        const endDampening = Math.pow(Math.max(0, Math.min(1, distanceFromEnd)), 0.5);
        const mouseEffect = Math.exp(-(distanceFromMouse * distanceFromMouse) / (2 * maxDistance * maxDistance));
        const amplitudeModifier = mouseEffect * endDampening;
        const amplitude = mirror ? -this.currentAmplitude : this.currentAmplitude;
        const y = Math.sin(Math.sqrt(Math.max(0, x) * this.currentFrequency) + this.offset) * amplitudeModifier * (0.1 * amplitude * this.width);
        return isNaN(y) ? 0 : y;
    }
    createWavePath() {
        let primaryPath = [
            "M",
            0,
            75
        ];
        let mirrorPath = [
            "M",
            0,
            75
        ];
        for(let x = 0; x <= this.width; x++){
            const y1 = 75 - this.calculateY(x);
            const y2 = 75 - this.calculateY(x, true);
            primaryPath.push("L", x, y1);
            mirrorPath.push("L", x, y2);
        }
        this.primaryPath.setAttribute("d", primaryPath.join(" "));
        this.mirrorPath.setAttribute("d", mirrorPath.join(" "));
    }
    startAnimation() {
        this.isAnimating = true;
        this.transitionStartTime = performance.now();
        this.currentFrequency = 0;
        this.currentAmplitude = 0;
        this.animate();
    }
    stopAnimation() {
        this.isAnimating = false;
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        this.currentFrequency = 0;
        this.currentAmplitude = 0;
        const straightLine = `M0,75 L${this.width},75`;
        this.primaryPath.setAttribute("d", straightLine);
        this.mirrorPath.setAttribute("d", straightLine);
    }
    animate(currentTime = performance.now()) {
        if (!this.isAnimating) return;
        this.updateTransitionValues(currentTime);
        this.offset += this.getCurrentSpeed();
        this.createWavePath();
        this.animationFrame = requestAnimationFrame(this.animate);
    }
}
customElements.define("sine-wave-arrow", $1f3ef02ab8c645b4$var$SineWaveArrow);


class $458374eb66b37f24$var$CaseStudiesLoader extends HTMLElement {
    constructor(){
        super();
        this.visibleCaseStudies = new Set();
        this.selectedOptions = [];
        this.categoryNames = [];
        this.baseUrl = this.getAttribute("base-url") || "";
    }
    connectedCallback() {
        this.initializeComponent();
    }
    initializeComponent() {
        this.setInitiallyVisibleCaseStudies();
        this.setupEventListeners();
    }
    setInitiallyVisibleCaseStudies() {
        const initialIds = this.getAttribute("initial-ids");
        if (initialIds) initialIds.split(",").forEach((id)=>this.visibleCaseStudies.add(id.trim()));
    }
    setupEventListeners() {
        this.addEventListener("filter-changed", this.handleFilterChange.bind(this));
        this.addEventListener("filter-initialized", this.handleFilterInitialization.bind(this));
        const loadMoreButton = this.querySelector('[name="load-more"]');
        if (loadMoreButton) loadMoreButton.addEventListener("click", ()=>this.loadMore());
    }
    handleFilterChange(event) {
        const { selectedOptions: selectedOptions, categoryNames: categoryNames } = event.detail;
        this.selectedOptions = selectedOptions;
        this.categoryNames = categoryNames;
        this.loadMore(true);
    }
    handleFilterInitialization(event) {
        const { selectedOptions: selectedOptions, categoryNames: categoryNames } = event.detail;
        this.selectedOptions = selectedOptions;
        this.categoryNames = categoryNames;
    }
    async loadMore(isReset = false) {
        try {
            const formData = this.prepareFormData();
            const response = await this.fetchCaseStudies(formData);
            this.handleResponse(response, isReset);
        } catch (error) {
            this.handleLoadError(error);
        }
    }
    prepareFormData() {
        const formData = new FormData();
        formData.append("CEUid", this.getAttribute("ceuid"));
        if (this.visibleCaseStudies.size > 0) formData.append("caseStudyIDs", Array.from(this.visibleCaseStudies).join(","));
        this.selectedOptions.forEach((option)=>formData.append("selectedoptions[]", option));
        formData.append("categorynames", this.categoryNames.join(","));
        formData.append("languageUid", this.getAttribute("language-uid"));
        return formData;
    }
    async fetchCaseStudies(formData) {
        const url = `${this.baseUrl}/?caseStudiesList=1&filter=1`;
        const response = await fetch(url, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
    }
    handleResponse(result, isReset) {
        const { maxLength: maxLength, previewContent: previewContent } = result;
        if (isReset) {
            this.visibleCaseStudies.clear();
            this.dispatchEvent(new CustomEvent("reset-case-studies", {
                bubbles: true,
                composed: true
            }));
        }
        this.dispatchStudies(previewContent);
        this.updateLoadMoreStatus(previewContent.length, maxLength);
    }
    dispatchStudies(caseStudies) {
        caseStudies.forEach((study)=>{
            if (!this.visibleCaseStudies.has(study.uid)) {
                this.visibleCaseStudies.add(study.uid);
                this.dispatchEvent(new CustomEvent("new-case-study", {
                    detail: study,
                    bubbles: true,
                    composed: true
                }));
            }
        });
    }
    updateLoadMoreStatus(contentLength, maxLength) {
        const loadMoreButton = this.querySelector('[name="load-more"]');
        if (loadMoreButton) loadMoreButton.style.display = contentLength <= maxLength ? "block" : "none";
    }
    handleLoadError(error) {
        console.error("Error:", error);
        this.dispatchEvent(new CustomEvent("case-studies-load-error", {
            detail: error,
            bubbles: true,
            composed: true
        }));
    }
}
customElements.define("case-studies-loader", $458374eb66b37f24$var$CaseStudiesLoader);


class $4fdc91f631b5caa2$var$CaseStudiesFilter extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this.selectedOptions = [];
        this.categoryNames = [];
        this.selects = [];
    }
    connectedCallback() {
        this.initializeComponent();
    }
    initializeComponent() {
        this.renderTemplate();
        this.setupEventListeners();
    }
    renderTemplate() {
        this.shadowRoot.innerHTML = `<slot></slot>`;
    }
    setupEventListeners() {
        const slot = this.shadowRoot.querySelector("slot");
        slot.addEventListener("slotchange", this.handleSlotChange.bind(this));
    }
    handleSlotChange(event) {
        this.selects = event.target.assignedElements().filter((el)=>el.tagName === "SELECT");
        this.selects.forEach((select)=>{
            select.addEventListener("change", this.handleFilterChange.bind(this));
        });
        this.updateSelectedOptions();
        this.updateCategoryNames();
        // Dispatch initial filter state
        this.dispatchEvent(new CustomEvent("filter-initialized", {
            detail: {
                selectedOptions: this.selectedOptions,
                categoryNames: this.categoryNames
            },
            bubbles: true,
            composed: true
        }));
    }
    updateSelectedOptions() {
        this.selectedOptions = this.selects.map((select)=>select.value === select.options[0].value ? select.options[0].value : select.value);
    }
    updateCategoryNames() {
        // for some reason the endpoint always wants to have all option values
        // of the category select, even if it's not used.
        const categorySelect = this.querySelector("#categories-select");
        if (categorySelect) this.categoryNames = Array.from(categorySelect.options).map((option)=>option.value);
    }
    handleFilterChange() {
        this.updateSelectedOptions();
        this.dispatchFilterChangedEvent();
    }
    dispatchFilterChangedEvent() {
        this.dispatchEvent(new CustomEvent("filter-changed", {
            detail: {
                selectedOptions: this.selectedOptions,
                categoryNames: this.categoryNames
            },
            bubbles: true,
            composed: true
        }));
    }
}
customElements.define("case-studies-filter", $4fdc91f631b5caa2$var$CaseStudiesFilter);


class $f53dd941f179a4a2$var$CaseStudiesRenderer extends HTMLElement {
    constructor(){
        super();
        this.isFirstReset = true;
        this.baseUrl = this.getAttribute("base-url") || "";
        this.templateId = this.getAttribute("template-id") || "caseStudyTemplate";
    }
    connectedCallback() {
        this.render();
        this.setupEventListeners();
    }
    render() {
        // Keep the existing content (including the server-rendered slot)
        const existingContent = this.innerHTML;
        this.innerHTML = `
      <div class="case-studies-container flow">
        ${existingContent}
      </div>
    `;
    }
    setupEventListeners() {
        window.addEventListener("new-case-study", this.handleNewCaseStudy.bind(this));
        window.addEventListener("reset-case-studies", this.resetCaseStudies.bind(this));
    }
    disconnectedCallback() {
        window.removeEventListener("new-case-study", this.handleNewCaseStudy.bind(this));
        window.removeEventListener("reset-case-studies", this.resetCaseStudies.bind(this));
    }
    handleNewCaseStudy(event) {
        const study = event.detail;
        const template = document.getElementById(this.templateId);
        if (!template) {
            console.error(`Template with id "${this.templateId}" not found`);
            return;
        }
        const caseStudyElement = this.createCaseStudyElement(template, study);
        this.querySelector(".case-studies-container").appendChild(caseStudyElement);
    }
    resetCaseStudies() {
        const container = this.querySelector(".case-studies-container");
        if (this.isFirstReset) {
            const serverRendered = this.querySelector('[slot="server-rendered"]');
            if (serverRendered) serverRendered.remove();
            this.isFirstReset = false;
        }
        container.innerHTML = "";
    }
    createCaseStudyElement(template, study) {
        const element = template.content.cloneNode(true);
        const headlineParent = element.querySelector(".template-headline").parentElement;
        headlineParent.innerHTML = study.title || study.header_title || study.nav_title || "";
        const textParent = element.querySelector(".template-text").parentElement;
        textParent.innerHTML = study.teaser_text || "";
        const link = element.querySelector('[name="link"]');
        link.href = study.page_uri;
        const contentTop = element.querySelector(".template-content-top");
        if (study.logo_uri) {
            const iconImg = document.createElement("img");
            iconImg.src = `${study.logo_uri}`;
            contentTop.parentElement.replaceChild(iconImg, contentTop);
        } else contentTop.remove();
        if (study.files) {
            const imageElement = element.querySelector(".template-media-content");
            const imageUrl = study.files.url;
            if (imageUrl) {
                imageElement.src = `${imageUrl}`;
                imageElement.classList.remove("template-media-content");
            }
        }
        return element.firstElementChild;
    }
}
customElements.define("case-studies-renderer", $f53dd941f179a4a2$var$CaseStudiesRenderer);




class $909d6fd9a65e1fa8$var$EventsLoader extends HTMLElement {
    constructor(){
        super();
        this.visibleEvents = new Set();
        this.baseUrl = this.getAttribute("base-url") || "";
        this.fixedTypes = this.getAttribute("data-fixed-types")?.split(",").filter(Boolean) || [];
        this.fixedTopics = this.getAttribute("data-fixed-topics")?.split(",").filter(Boolean) || [];
        this.selectedOptions = [
            ...this.fixedTypes,
            ...this.fixedTopics
        ];
    }
    updateSelectedOptions(selectedOptions) {
        this.selectedOptions = [
            ...this.fixedTypes,
            ...this.fixedTopics,
            ...selectedOptions.filter((option)=>!this.fixedTypes.includes(option) && !this.fixedTopics.includes(option))
        ];
    }
    connectedCallback() {
        this.initializeComponent();
    }
    initializeComponent() {
        this.setInitiallyVisibleEvents();
        this.setupEventListeners();
    }
    setInitiallyVisibleEvents() {
        const initialIds = this.getAttribute("initial-ids");
        if (initialIds) initialIds.split(",").forEach((id)=>this.visibleEvents.add(id.trim()));
        else this.loadMore({
            isReset: true
        });
    }
    setupEventListeners() {
        this.addEventListener("filter-changed", (e)=>{
            e.stopPropagation();
            this.handleFilterChange(e);
        });
        this.addEventListener("filter-initialized", (e)=>{
            e.stopPropagation();
            this.handleFilterInitialization(e);
        });
        const loadMoreButton = this.querySelector('[name="load-more"]');
        if (loadMoreButton) loadMoreButton.addEventListener("click", ()=>this.loadMore());
    }
    handleFilterChange(event) {
        const { selectedOptions: selectedOptions } = event.detail;
        this.updateSelectedOptions(selectedOptions);
        this.loadMore({
            isReset: true
        });
    }
    handleFilterInitialization(event) {
        const { selectedOptions: selectedOptions } = event.detail;
        this.updateSelectedOptions(selectedOptions);
    }
    async loadMore(options = {}) {
        try {
            const formData = this.prepareFormData();
            const response = await this.fetchEvents(formData);
            this.handleResponse(response, options.isReset);
        } catch (error) {
            this.handleLoadError(error);
        }
    }
    prepareFormData() {
        const formData = new FormData();
        formData.append("CEUid", this.getAttribute("ceuid"));
        formData.append("eventsIDs", Array.from(this.visibleEvents).join(","));
        formData.append("doktypenames", this.fixedTypes.join(","));
        formData.append("sortingfield", this.getAttribute("data-sortingfield") || "inputdate");
        formData.append("sortingorder", this.getAttribute("data-sortingorder") || "ASC");
        formData.append("maxItems", this.getAttribute("data-max-items") || "12");
        this.selectedOptions.forEach((option)=>formData.append("selectedoptions[]", option));
        formData.append("languageUid", this.getAttribute("language-uid"));
        return formData;
    }
    async fetchEvents(formData) {
        const baseUrlTrimmed = this.baseUrl.endsWith("/") ? this.baseUrl.slice(0, -1) : this.baseUrl;
        const url = `${baseUrlTrimmed}?eventsList=1&filter=1`;
        const response = await fetch(url, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
    }
    handleResponse(result, isReset) {
        const { maxLength: maxLength, previewContent: previewContent } = result;
        if (isReset) {
            this.visibleEvents.clear();
            this.dispatchEvent(new CustomEvent("reset-events", {
                bubbles: false,
                composed: false
            }));
        }
        this.dispatchEvents(previewContent);
        this.updateLoadMoreStatus(previewContent.length, maxLength);
    }
    dispatchEvents(events) {
        events.forEach((event)=>{
            if (!this.visibleEvents.has(event.uid)) {
                this.visibleEvents.add(event.uid);
                this.dispatchEvent(new CustomEvent("new-event", {
                    detail: event,
                    bubbles: false,
                    composed: false
                }));
            }
        });
    }
    updateLoadMoreStatus(contentLength, maxLength) {
        const loadMoreButton = this.querySelector('[name="load-more"]');
        if (loadMoreButton) loadMoreButton.style.display = contentLength <= maxLength ? "block" : "none";
    }
    handleLoadError(error) {
        console.error("Error:", error);
        this.dispatchEvent(new CustomEvent("events-load-error", {
            detail: error,
            bubbles: false,
            composed: false
        }));
    }
}
customElements.define("events-loader", $909d6fd9a65e1fa8$var$EventsLoader);


class $6666cbdd0a3e3363$var$EventsFilter extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
        this.selectedOptions = [];
        this.selects = [];
    }
    connectedCallback() {
        this.initializeComponent();
    }
    initializeComponent() {
        this.renderTemplate();
        this.setupEventListeners();
    }
    renderTemplate() {
        this.shadowRoot.innerHTML = `<slot></slot>`;
    }
    setupEventListeners() {
        const slot = this.shadowRoot.querySelector("slot");
        slot.addEventListener("slotchange", this.handleSlotChange.bind(this));
    }
    handleSlotChange(event) {
        this.selects = event.target.assignedElements().filter((el)=>el.tagName === "SELECT");
        this.selects.forEach((select)=>{
            select.addEventListener("change", this.handleFilterChange.bind(this));
        });
        this.updateSelectedOptions();
        // Dispatch initial filter state
        this.dispatchEvent(new CustomEvent("filter-initialized", {
            detail: {
                selectedOptions: this.selectedOptions
            },
            bubbles: true,
            composed: true
        }));
    }
    updateSelectedOptions() {
        this.selectedOptions = this.selects.map((select)=>select.value === select.options[0].value ? select.options[0].value : select.value);
    }
    handleFilterChange() {
        this.updateSelectedOptions();
        this.dispatchFilterChangedEvent();
    }
    dispatchFilterChangedEvent() {
        this.dispatchEvent(new CustomEvent("filter-changed", {
            detail: {
                selectedOptions: this.selectedOptions
            },
            bubbles: true,
            composed: true
        }));
    }
}
customElements.define("events-filter", $6666cbdd0a3e3363$var$EventsFilter);


class $0972dab98d94ddf1$var$EventsRenderer extends HTMLElement {
    constructor(){
        super();
        this.templateId = this.getAttribute("template-id") || "eventTemplate";
        this.boundHandleNewEvent = this.handleNewEvent.bind(this);
        this.boundResetEvents = this.resetEvents.bind(this);
    }
    connectedCallback() {
        this.render();
        this.loader = this.closest("events-loader");
        if (!this.loader) {
            console.error("EventsRenderer must be a child of EventsLoader");
            return;
        }
        this.setupEventListeners();
    }
    render() {
        // Keep the existing content (including the server-rendered slot)
        const existingContent = this.innerHTML;
        this.innerHTML = `
      <div class="layout-grid-container-3col">
        <div class="layout-grid events-container">
          ${existingContent}
        </div>
      </div>
    `;
    }
    setupEventListeners() {
        this.loader.addEventListener("new-event", this.boundHandleNewEvent);
        this.loader.addEventListener("reset-events", this.boundResetEvents);
    }
    disconnectedCallback() {
        if (this.loader) {
            this.loader.removeEventListener("new-event", this.boundHandleNewEvent);
            this.loader.removeEventListener("reset-events", this.boundResetEvents);
        }
    }
    handleNewEvent(event) {
        const eventData = event.detail;
        const template = document.getElementById(this.templateId);
        if (!template) {
            console.error(`Template with id "${this.templateId}" not found`);
            return;
        }
        const eventElement = this.createEventElement(template, eventData);
        this.querySelector(".events-container").appendChild(eventElement);
    }
    resetEvents() {
        const container = this.querySelector(".events-container");
        container.innerHTML = "";
    }
    createEventElement(template, eventData) {
        const element = template.content.cloneNode(true);
        const headline = element.querySelector('[name="headline"]');
        if (headline?.parentElement) headline.parentElement.innerHTML = eventData.abstract;
        const link = element.querySelector('[name="link"]');
        if (link) link.href = eventData.event_uri;
        const eventDate = element.querySelector('[name="event-date"]');
        if (eventDate && eventData.inputdate) {
            const date = new Date(eventData.inputdate * 1000);
            const locale = navigator.language || "de-DE";
            eventDate.textContent = date.toLocaleDateString(locale, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            });
            if (eventData.additionaleventinformation) {
                const separator = " | ";
                eventDate.textContent = eventDate.textContent + separator;
            }
        }
        const eventType = element.querySelector('[name="event-type"]');
        if (eventType) eventType.textContent = eventData.additionaleventinformation;
        const imageElement = element.querySelector('[name="image"]');
        if (eventData.files?.url && imageElement) {
            imageElement.src = eventData.files.url;
            imageElement.alt = eventData.abstract;
        }
        return element.firstElementChild;
    }
}
customElements.define("events-renderer", $0972dab98d94ddf1$var$EventsRenderer);




console.log(`




 
                  @@@@@@@@    @@@@         @@@@  @@@@@@@@@@@@    @@@@ @@@@@@@@@@@@@@@@              
               @@@@@@@@@@@@@@ @@@@@       @@@@@ @@@@@@@@@@@@@@@  @@@@ @@@@@@@@@@@@@@@@              
              @@@@        @@@@  @@@@     @@@@   @@@@       @@@@  @@@@       @@@@                    
              @@@@@@@@           @@@@@ @@@@@    @@@@      @@@@@  @@@        @@@@                    
               @@@@@@@@@@@@@@@     @@@@@@@@     @@@@@@@@@@@@@    @          @@@@                    
                         @@@@@      @@@@@       @@@@        @@@@ @@@        @@@@                    
              @@@@         @@@       @@@@       @@@@        @@@@ @@@@       @@@@                    
               @@@@@@@@@@@@@@@       @@@@       @@@@@@@@@@@@@@@  @@@@       @@@@                    
                  @@@@@@@@@          @@@@        @@@@@@@@@@@@    @@@@       @@@@               


              Wenn Du das hier liest, bewirb Dich jetzt:

              https://sybit.com/de/karriere




			  
`);
/**
 * Resize Animation Stopper
 *
 * This code adds a class to the body element during window resizing
 * to temporarily disable all animations and transitions. This helps
 * reduce visual jank and improve performance when resizing the window,
 * especially on pages with many animated elements.
 *
 * The class is removed shortly after resizing stops, allowing
 * animations to resume during normal page interaction.
 */ let $00434a95140535cd$var$resizeTimer;
window.addEventListener("resize", ()=>{
    document.body.classList.add("resize-animation-stopper");
    clearTimeout($00434a95140535cd$var$resizeTimer);
    $00434a95140535cd$var$resizeTimer = setTimeout(()=>{
        document.body.classList.remove("resize-animation-stopper");
    }, 400);
});
/**
 * This script uses the IntersectionObserver API to observe elements with the attribute
 * `in-viewport-observer`. When the element enters the viewport (at least 10% visible),
 * it dynamically adds the attribute `in-viewport` to the element.
 *
 * When the element leaves the viewport, the `in-viewport` attribute is removed.
 *
 * Usage:
 * 1. Add `in-viewport-observer` (without a value) to any HTML element you want to observe.
 * 2. The script will automatically observe those elements and toggle the `in-viewport` attribute
 *    when the element becomes visible or invisible within the viewport.
 * 3. If the element once entered the viewport, it will also have the attribute `was-in-viewport`.
 *
 * Example:
 * <div in-viewport-observer></div>
 *
 * CSS can be used to style the elements based on whether they are in the viewport:
 * [in-viewport] {
 *     opacity: 1;
 *     background-color: lightgreen;
 * }
 *
 * CSS can be used to style elements which were in the viewport at least once:
 * [was-in-viewport] {
 *    background-color: lightblue;
 * }
 *
 * Customize the observer's threshold, root, or behavior by modifying the observerOptions.
 */ document.addEventListener("DOMContentLoaded", ()=>{
    const observerOptions = {
        root: null,
        threshold: 0.1
    };
    const observerCallback = (entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.setAttribute("in-viewport", "true");
                entry.target.setAttribute("was-in-viewport", "true");
            } else entry.target.removeAttribute("in-viewport");
        });
    };
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    document.querySelectorAll("[in-viewport-observer]").forEach((element)=>{
        observer.observe(element);
    });
});
document.addEventListener("DOMContentLoaded", ()=>{
    let el = document.querySelector("h1 > strong");
    if (el) {
        let b = (0, (/*@__PURE__*/$parcel$interopDefault($05a697981a0796ab$exports)))(el, {
            characters: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#%&!?@"
        });
        b.reveal(4000);
    }
});

})();
//# sourceMappingURL=index.js.map
